/* Website 3: theme-local two-page navigation. No commerce state or cart is stored. */
(() => {
  const init = () => {
    const root=window.Shopify?.routes?.root || '/', shopPath=root+'pages/shop';
    const builder=document.getElementById('detergent-builder'),isShop=location.pathname===shopPath||(!!builder&&document.body.dataset.fecPageType==='product');
    const previewId=window.Shopify?.theme?.role==='unpublished'?String(window.Shopify.theme.id):null;
    const sameStore=u=>u.origin===location.origin||['firsteditionsco.com','www.firsteditionsco.com','dfc7e7.myshopify.com'].includes(u.hostname);
    const valid=s=>['high-lady','shadow-daddy'].includes(s), key='fec-website3-scent-intent';
    const currentParams=new URLSearchParams(location.search);
    let scent=currentParams.get('plan_scent');
    try{if(!valid(scent))scent=sessionStorage.getItem(key);}catch(_){}
    if(!valid(scent))scent='high-lady';
    const remember=s=>{if(!valid(s))return;scent=s;try{sessionStorage.setItem(key,s);}catch(_){}};
    remember(scent);
    const urlFor=(hash,intent)=>{const u=new URL(shopPath,location.origin);if(previewId){u.searchParams.set('preview_theme_id',previewId);u.searchParams.set('pb','0');}if(valid(intent))u.searchParams.set('plan_scent',intent);u.hash=hash;return u;};
    document.querySelectorAll('a[href]').forEach(link=>{
      if(link.classList.contains('fec-skip-link'))return;
      let u;try{u=new URL(link.getAttribute('href'),location.href);}catch(_){return;}
      if(!sameStore(u))return;
      // Primary page navigation goes to page tops; only promotional links deep-link to the builder.
      if(link.closest('.fec-website3-primary-nav')){if(previewId){u.searchParams.set('preview_theme_id',previewId);u.searchParams.set('pb','0');}link.href=u.href;return;}
      const shopping=u.pathname===shopPath||u.hash==='#detergent-builder'||link.hasAttribute('data-fec-home-builder');
      const reviews=u.pathname===root+'pages/reviews'||u.hash==='#customer-reviews';
      if(!shopping&&!reviews)return;
      let intent=u.searchParams.get('plan_scent');
      const highLadyContext=location.pathname===root+'products/high-lady-hl24lp1'||location.pathname.startsWith(root+'pages/high-lady-')||location.pathname===root+'pages/book-style-laundry-detergent-sheets';
      if(!valid(intent)&&(/high lady|lilac\s*&\s*pear/i.test(link.textContent)||(highLadyContext&&link.closest('main'))))intent='high-lady';
      if(valid(intent))link.dataset.fecScentIntent=intent;
      const hash=reviews?'customer-reviews':u.hash==='#faq'?'faq':'detergent-builder';
      link.dataset.fecWebsite3Destination=hash;
      link.href=urlFor(hash,valid(intent)?intent:scent).href;
    });
    const header=document.querySelector('.fec-site-chrome');
    const move=target=>{if(!target)return;target.setAttribute('tabindex','-1');target.focus({preventScroll:true});window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top+scrollY-(header?.getBoundingClientRect().height||100)-16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
    document.addEventListener('click',e=>{
      const scentControl=e.target.closest('[data-fec-sd-scent]');if(scentControl)remember('shadow-daddy');
      const hl=e.target.closest('input[name="scent"][value="high-lady"]');if(hl)remember('high-lady');
      const a=e.target.closest('a[data-fec-website3-destination],a[data-fec-edition-link]');
      if(!a||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
      if(a.hasAttribute('data-fec-edition-link')){const target=document.getElementById('inside-every-edition');if(target){e.preventDefault();move(target);}return;}
      const explicit=a.dataset.fecScentIntent,hash=a.dataset.fecWebsite3Destination;
      if(valid(explicit))remember(explicit);
      a.href=urlFor(hash,scent).href;
      if(!isShop||!builder)return;
      const target=document.getElementById(hash);if(!target)return;
      e.preventDefault();const menu=a.closest('details');if(menu)menu.open=false;
      move(target);
      if(valid(explicit))document.dispatchEvent(new CustomEvent('fec:select-scent',{detail:{scent:explicit}}));
      const u=new URL(location.href);if(previewId){u.searchParams.set('preview_theme_id',previewId);u.searchParams.set('pb','0');}u.searchParams.set('plan_scent',scent);u.hash=hash;history.replaceState(history.state,'',u);
    });
    document.addEventListener('fec:select-scent',e=>remember(e.detail?.scent));
    if(isShop&&builder){
      const resize=()=>builder.style.setProperty('--fec-compact-header',Math.ceil(header?.getBoundingClientRect().height||100)+'px');resize();if(header&&window.ResizeObserver)new ResizeObserver(resize).observe(header);
      // Existing builder owns the guarded Shadow Daddy detail dialog; this never adds/checks it.
      if(valid(currentParams.get('plan_scent')))requestAnimationFrame(()=>document.dispatchEvent(new CustomEvent('fec:select-scent',{detail:{scent:currentParams.get('plan_scent')}})));
      if(location.hash)requestAnimationFrame(()=>move(document.getElementById(location.hash.slice(1))));
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
(() => {
  const init=()=>{
    const bar=document.querySelector('[data-fec-announcement]');if(!bar)return;
    const track=bar.querySelector('[data-fec-marquee-track]'),group=bar.querySelector('[data-fec-marquee-group]');
    const size=()=>{
      track.querySelectorAll('[data-fec-marquee-clone]').forEach(el=>el.remove());
      const distance=group.getBoundingClientRect().width;if(!distance)return;
      track.style.setProperty('--fec-marquee-distance',`${distance}px`);
      track.style.setProperty('--fec-marquee-duration',`${distance/46}s`);
      // Enough identical, inert text groups to cover the widest viewport throughout the loop.
      for(let n=0;n<Math.ceil(bar.clientWidth/distance)+1;n++){
        const clone=group.cloneNode(true);clone.removeAttribute('data-fec-marquee-group');
        clone.dataset.fecMarqueeClone='';clone.setAttribute('aria-hidden','true');clone.inert=true;track.append(clone);
      }
      bar.dataset.marqueeReady='true';
    };
    size();document.fonts?.ready.then(size);if(window.ResizeObserver)new ResizeObserver(size).observe(bar);
  };if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
